const baseUrl = process.env.VUE_APP_WP_URL;
export default {
    async duplicateNewsletter(campaign_id) {
        const endpoint = "newsletter/duplicate";
        var url = new URL(baseUrl + "/" + endpoint);
        url.searchParams.append("campaign_id", campaign_id);

        const response = await fetch(url, {
            method: "get",
            credentials: "include",
            mode: "cors"
        });
        return response;
    },
    async postNewsletterReceiver(receiver) {
        const endpoint = "newsletter/subscribers/add";

        const response = await fetch(baseUrl + "/" + endpoint, {
            method: "post",
            credentials: "include",
            mode: "cors",
            body: JSON.stringify(receiver)
        });
        return response;
    }
};
